import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const calibrationUploadFileThunk = createAsyncThunk(
  "calibration/uploadFile",
  proceedThunk(api.auth.calibration.upload)
);

export const calibrationsListThunk = createAsyncThunk(
  "calibration/list",
  proceedThunk(api.auth.calibration.list)
);

export const fetchCalibrationThunk = createAsyncThunk(
  "calibration/fetch",
  proceedThunk(api.auth.calibration.get)
);

export const enableCalibrationThunk = createAsyncThunk(
  "calibration/enable",
  proceedThunk(api.auth.calibration.enable)
);

export const enableAutoCalibrationThunk = createAsyncThunk(
  "calibration/enableAuto",
  proceedThunk(api.auth.calibration.enableAuto)
);

export const deleteCalibrationThunk = createAsyncThunk(
  "calibration/delete",
  proceedThunk(api.auth.calibration.delete)
);

export const renameCalibrationThunk = createAsyncThunk(
  "calibration/rename",
  proceedThunk(api.auth.calibration.rename)
);
